// Module
var code = "<div class=\"was-this-useful__result\"> <div class=\"was-this-useful__sub-title was-this-useful__sub-title--bold\" system-dictionary=\"WasThisUsefulResultTitle\"> </div> <div class=\"was-this-useful__sub-title\" system-dictionary=\"WasThisUsefulResultDesription\"></div> </div>";
// Exports
module.exports = code;